import SiteHeader from "@/components/landing/SiteHeader";
import HeroSection from "@/components/landing/HeroSection";
import TrustedByAndIntro from "@/components/landing/TrustedByAndIntro";
import GetTheAppSection from "@/components/landing/GetTheAppSection";
import HowItWorksDark from "@/components/landing/HowItWorksDark";
import MembersSection from "@/components/landing/MembersSection";
import InstagramCollageSection from "@/components/landing/InstagramCollageSection";
import CreatorCalloutBand from "@/components/landing/CreatorCalloutBand";
import LeadFormSection from "@/components/landing/LeadFormSection";
import SiteFooter from "@/components/landing/SiteFooter";
import { isAppContext } from "@/lib/appContext";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white text-black">
      <SiteHeader />
      <main>
        <HeroSection />
        <TrustedByAndIntro />
        {/* "Get the App" billboard: transparent band that slides over the
            pinned TrustedByAndIntro, letting its watermark + logos show
            through around the dark card (Bill, 8/31). */}
        {!isAppContext() && <GetTheAppSection />}
        {/* Cascade: each section pins (sticky) and the next slides up over it,
            starting by sliding over the pinned TrustedByAndIntro. */}
        <div className="relative z-10">
          <HowItWorksDark />
          <MembersSection />
          <InstagramCollageSection />
          <CreatorCalloutBand />
          <LeadFormSection />
        </div>
      </main>
      {/* Footer lives outside the cascade wrapper so the pinned sections release
          before it, but keeps z-10 so it still paints above the pinned
          TrustedByAndIntro. */}
      <div className="relative z-10">
        <SiteFooter />
      </div>
    </div>
  );
};

export default LandingPage;
